/**
 * @description - 字符串字节计算
 * @param {String} str
 * @returns - 字符串字节数 
 */
export const bytesCount = function(str) {
    var bytesCount = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charAt(i);
          if (/^[\u0000-\u00ff]$/.test(c)) //匹配双字节
              {
                  bytesCount += 1;
              }
          else
              {
                  bytesCount += 2;
              }
    }
    return bytesCount;
}
/**
 * @description - 按字节数截取字符
 * @param {String} str - 需截取的字符串 
 * @param {Number} len - 需截取的字节数 
 * @param {String} endstr - 截取超出需显示的结束字符
 */
export const cutBytes = function(str, len, endstr) {
    if(!str) return str
    var len = +len,
        endstr = typeof(endstr) == 'undefined' ? "..." : endstr.toString(),
        endstrBl = bytesCount(endstr);
        function n2(a) {var n = a / 2 | 0; return (n > 0 ? n : 1)}//用于二分法查找
        if (!(str + "").length || !len || len <= 0) {
            return "";
        }
        if(len<endstrBl){
            endstr = "";
            endstrBl = 0;
        }
        var lenS = len - endstrBl,
        _lenS = 0,
        _strl = 0;
        while (_strl <= lenS) {
            var _lenS1 = n2(lenS - _strl),
            addn = bytesCount(str.substr(_lenS, _lenS1));
            if (addn == 0) {return str;}
            _strl += addn
            _lenS += _lenS1
        }
        if(bytesCount(str).length - _lenS > endstrBl || bytesCount(str.substring(_lenS-1))>endstrBl){
            return str.substr(0, _lenS - 1) + endstr
        }else{
            return str;
        }  
}
/**
 * @description - 格式化时间戳
 * @param {Number} times - 时间戳 
 * @param {String} formatStr - 格式化模板 
 */
export const dateFormat = function (times, formatStr) {
    let timestamp;
    if (/^\d{12,15}$/.test(times)) {
        timestamp = times;
    } else if (/^\d{9,11}$/.test(times)) {
        timestamp = times * 1000;
    } else {
        return times;
    }
    let format = formatStr || 'yyyy/MM/dd'
    const currentDate = new Date(parseInt(timestamp))
    const date = {
        "M+": currentDate.getMonth() + 1,
        "d+": currentDate.getDate(),
        "h+": currentDate.getHours(),
        "m+": currentDate.getMinutes(),
        "s+": currentDate.getSeconds()
    }
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (currentDate.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (const k in date) {
        if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
        }
    }
    return format;
}
export const deepCopy = function (source) {
    if (Array.isArray(source)) {
        const result = [];
        for (const key in source) {
            result[key] = typeof source[key] === 'object' ? deepCopy(source[key]) : source[key];
        }
        return result;
    } else {
        const result = {};
        for (const key in source) {
            result[key] = typeof source[key] === 'object' ? deepCopy(source[key]) : source[key];
        }
        return result;
    }
}
export const deepCopyExtend = function(data) {
    let tempdata = {}

    for(let attr in data) {

        if(data[attr] instanceof Array) {

            let tempValue = data[attr];
            let tempValueArr = [];

            for(let i = 0; i < tempValue.length; i++) {

                if(typeof tempValue[i] == 'object') {
                    let copyObj = deepCopyExtend(tempValue[i])
                    tempValueArr.push(copyObj)
                } else {
                    tempValueArr.push(tempValue[i])
                }
            }

            tempdata[attr] = tempValueArr;
        } else {

            if(typeof data[attr] == 'object' && Object.getPrototypeOf(data[attr]).constructor.name != 'Date') {
                tempdata[attr] = this.deepCopy(data[attr])
            } else {
                tempdata[attr] = data[attr]
            }
        }
    }

    return tempdata;
}

export default {
    cutBytes,
    dateFormat,
    deepCopy,
    deepCopyExtend
}


// WEBPACK FOOTER //
// ./src/comm/js/utils/common.js